import { Component, OnInit } from '@angular/core';
import { MeteoriteCartService } from '../meteorite-cart.service';

@Component({
  selector: 'met-cart',
  templateUrl: './meteorite-cart.component.html',
  styleUrls: ['./meteorite-cart.component.scss']
})
export class MeteoriteCartComponent implements OnInit {

  public loadingCartId: string;

  constructor(
    public cartService: MeteoriteCartService
  ) {

  }

  ngOnInit() {

  }

  addSelectedItem(product): void {
    if (product) this.cartService.addItems([{ ...product, quantity: 1, product_id: product.id }]);
  }

  onCmsSave(event) {
    console.log('onCmsSave :', event);
  }
}


